module.exports = __webpack_public_path__ + "img/img-finalizado.7e07fd1c.png";